import { InjectionToken } from '@angular/core';

export interface AppConfiguration {
  production: boolean;
  UniLeader: string;
  UniSystemAPI: string;
  UniTeacher: string;
  UtilsUrl: string;
  SupportUrl: string;
  code_security: string;
  HelpUrl: string;
  document_So_len_lop: string;
}

export const AppConfig = new InjectionToken<AppConfiguration>('@@appConfiguration');
